import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import NavBar from "./NavBar";
import TopBar from "./TopBar";
import { Box } from "@material-ui/core";
// import SettingsContext from "src/context/";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100%",
    overflow: "hidden",
    width: "100%",
  },
  root: {
    backgroundColor: "#F8FAFB",
    // overflow: "hidden",
    position: "relative",
    height: "100vh",
  },

  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    position: "relative",
    backgroundColor: "#fff",
    paddingTop: 70,
    minHeight: "calc(100vh - 75px)",
    [theme.breakpoints.up("lg")]: {
      paddingLeft: 306,
    },
    "@media (max-width:767px)": {
      paddingTop: "70px !important",
    },
  },

  contentContainer: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    marginBottom: "30px",
  },

  dashboardWrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    position: "relative",
    backgroundColor: "#F8FAFB",
    paddingTop: 40,
    minHeight: "calc(100vh - 75px)",
    [theme.breakpoints.up("lg")]: {
      paddingLeft: 306,
    },
    "@media (max-width:767px)": {
      paddingTop: "70px !important",
    },
  },

  dashboardContent: {
    flex: "1 1 auto",
    height: "100%",
    overflow: "hidden",
    position: "relative",
    padding: "20px",
    // padding: "28px 25px 25px ",
    [theme.breakpoints.down("md")]: {
      padding: "45px 10px 10px ",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "10px 10px 10px ",
    },
  },

  content: {
    flex: "1 1 auto",
    height: "100%",
    overflow: "hidden",
    position: "relative",
    padding: "28px 25px 25px ",
    [theme.breakpoints.down("md")]: {
      padding: "25px 10px 10px ",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "10px 10px 10px ",
    },
  },
  footer: {
    display: "flex",
     position: "fixed",
     bottom: "0px",
    justifyContent: "center",
    background: "#636f83",
    height: "30px",
    width: "100%",
    alignItems: "center",
    color: "#fff",
    [theme.breakpoints.down("xs")]: {
      fontSize: "13px",
    },
  },
}));

const DashboardLayout = ({ children }) => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  // const themeSeeting = useContext(SettingsContext);

  const dashboardRoute = window.location.pathname === "/dashboard";

  return (
    <div className={classes.root}>
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <Box
        mb={3}
        className={
          dashboardRoute ? classes.dashboardWrapper : classes.dashboardWrapper
        }
      >
        <div className={classes.contentContainer}>
          <div
            className={
              dashboardRoute
                ? classes.dashboardContent
                : classes.dashboardContent
            }
            id="main-scroll"
          >
            {children}
          </div>
        </div>
      </Box>
      <div
        className={classes.footer}
        style={{
   backgroundColor: " #FF7F26",
    zIndex: 9999, 
        }}
      >
        © 2025 Fululizo Media | Integral Media Limited
      </div>
    </div>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
